import {
  TRY_POLL,
  TRY_POLL_SUCCESS,
  TRY_POLL_CLEAN,
  TRY_POLL_ERROR,
} from "./actionTypes"

export const tryPoll = form => ({
  type: TRY_POLL,
  payload: { form },
})

export const tryPollSuccess = poll => {
  return {
    type: TRY_POLL_SUCCESS,
    payload: { poll },
  }
}

export const tryPollClean = () => {
  return {
    type: TRY_POLL_CLEAN,
    payload: {},
  }
}

export const tryPollError = error => {
  return {
    type: TRY_POLL_ERROR,
    payload: error,
  }
}
